import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SEOHead } from "@/components/SEOHead";

const Privacy = () => {
  return (
    <div className="min-h-screen bg-white font-sans text-foreground flex flex-col">
      <SEOHead
        title="Privacy Policy | Clean Marketing"
        description="How Clean Marketing collects, uses, and protects your personal information when you use our window cleaning marketing services."
        canonical="/privacy"
      />
      <Header />
      <main className="flex-grow container mx-auto px-4 py-16 max-w-3xl">
        <h1 className="text-4xl font-bold text-secondary mb-8">
          Privacy Policy
        </h1>
        <div className="space-y-6 text-slate-600 leading-relaxed">
          <p>Last updated: {new Date().toLocaleDateString()}</p>

          <h2 className="text-2xl font-semibold text-secondary mt-8 mb-4">
            1. Information We Collect
          </h2>
          <p>
            We collect information you provide directly to us, such as when you
            create an account, fill out a form, request support, or communicate
            with us. This may include your name, email address, phone number,
            company details, and payment information.
          </p>

          <h2 className="text-2xl font-semibold text-secondary mt-8 mb-4">
            2. How We Use Your Information
          </h2>
          <p>
            We use the information we collect to provide, maintain, and improve
            our services, process transactions, send technical notices and
            support messages, and communicate with you about products, services,
            and events offered by Clean Marketing.
          </p>

          <h2 className="text-2xl font-semibold text-secondary mt-8 mb-4">
            3. Data Security
          </h2>
          <p>
            We implement appropriate technical and organizational measures to
            protect the security of your personal information. However, please
            note that no method of transmission over the Internet or electronic
            storage is 100% secure.
          </p>

          <h2 className="text-2xl font-semibold text-secondary mt-8 mb-4">
            4. Sharing of Information
          </h2>
          <p>
            We do not sell, trade, or otherwise transfer your personally
            identifiable information to outside parties except as described in
            this policy or with your consent. We may share information with
            trusted third-party service providers who assist us in operating our
            website or servicing you.
          </p>

          <h2 className="text-2xl font-semibold text-secondary mt-8 mb-4">
            5. Your Rights
          </h2>
          <p>
            Depending on your location, you may have rights regarding your
            personal information, including the right to access, correct, or
            delete your data. Contact us to exercise these rights.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Privacy;
